import axios from "axios";
import { GetSpecificCulture } from "./cultureSpecificMixin.js";



export default async function submitForm(store) {
  const personalDetails = store[store.currentCulture].values.personalDetails;
  //const userDetails = store[store.currentCulture].values.userDetails;
  const productDetails = store[store.currentCulture].values.productDetails;
  const insuranceDetails = store[store.currentCulture].values.insuranceDetails;


  //
  // ADDED TO PROVIDE CORRECT BACKEND FEEDBACK
  if (personalDetails.educationStarted == "" || !personalDetails.educationStarted) personalDetails.educationStarted = "01-01-0001";
  if (personalDetails.educationExpectedEnd == "" || !personalDetails.educationExpectedEnd) personalDetails.educationExpectedEnd = "01-01-0001";
  const culture = store.currentCulture;
  const memberNo = store[store.currentCulture].values.memberNo;

  const payload = {
    memberNo : memberNo,
    //new 
    insurance : insuranceDetails.homeInsurance ?? false,
    //new 
    recruiter: productDetails.recruiter,
    recruitmentState: productDetails.recruitmentState,
    culture: GetSpecificCulture(culture),
    formId: store.formId,
    pageviewGuid: store.pageviewGuid,
    subscriptionType: store.subscriptionType,
    promocode: productDetails.promocodeused ? productDetails.promocode : null,
    cpr: personalDetails.cpr,
    firstname: personalDetails.firstname,
    lastname: personalDetails.lastname,
    email: personalDetails.emailaddress,
    phone: personalDetails.phonearea + personalDetails.phone,
    alreadyUnionMember: personalDetails.unionmember,
    alreadyHaveUnemploymentInsurance: personalDetails.unemploymentinsurance,
    consents: personalDetails.consents.filter((x) => x.checked && x.visible && x.returninsetconsent).map((x) => parseInt(x.id.replace("consent_", ""))),
    ...(personalDetails.unemploymentinsurance == "JaAnden" ? { unemploymentInsuranceCompany: personalDetails.unemploymentInsurancewhichone } : {}),
  };

  // Add conditional parameters based on "nocpr"
  const isForeigner = GetSpecificCulture(culture) != "da-dk";

  const nationalityvalues = isForeigner ? { communicationLanguage: personalDetails.informationLanguage } : {};

  // add conditional parameters based on "unionmember"
  const unionvalues = personalDetails.unionmember === "ja" ? { terminateUnionMembership: personalDetails.unionunsubscribe == "ja" ? true : false, ...(personalDetails.unionunsubscribe === "ja" && { currentUnion: personalDetails.unionwhichone }) } : {};

  const residence = {
    recentGraduateStartedInDK: personalDetails.dimStudentInDenmark == "ja",
  };

  const unemploymentInsurancevalues = productDetails.unemploymentinsuranceselected
    ? {
        payBySalary: false,
        unemploymentInsuranceAdded: true,
        alreadyHaveUnemploymentInsurance: personalDetails.unemploymentinsurance,
        usedToHaveUnemploymentInsurance: personalDetails.oldUnemploymentinsurance,
        unemploymentInsuranceCompany: personalDetails.unemploymentInsurancewhichone,
        oldUnemploymentInsuranceCompany: personalDetails.unemploymentInsurancewhichone,
        recentGraduate: personalDetails.dimStudent == "ja",
        recentGraduateUseRights: personalDetails.dimRights == "ja",
        recentGraduateRejectRights: personalDetails.dimRightsNO === true || personalDetails.dimRightsNO === "true",
        recentGraduateFree: personalDetails.dimStudentFree == "ja",
        recentGraduatePension: personalDetails.dimStudentPension == "ja",
        recentGraduateYesNo: personalDetails.dimStudentYesno == "ja",
        recentGraduateSU: personalDetails.dimStudentSu == "trorSu"
      }
    : {};

  // add conditional parameters based on "subscriptionType == employed"
  const employedvalues =
    store.subscriptionType === "employed"
      ? {
          educationStart: personalDetails.educationStarted,
          educationEnd: personalDetails.educationExpectedEnd,
          educationInstitute: personalDetails.educationInstitution,
          currentEducation: personalDetails.educationCurrent,
          highestEducation: personalDetails.educationLevel.id,
          companyName: personalDetails.companyName,
          companyAddress: personalDetails.companyAddress,
          companyZipcode: personalDetails.companyPostalCode,
          companyWorkAreaPrioList: personalDetails.workSets.map((workSet, index) => {
            return {
              workArea: workSet.area.id,
              workAreaName: workSet.area.name,
              workFunction: workSet.function.id,
              workFunctionName: workSet.function.name,
              priority: index,
            };
          }),
          payBySalary: personalDetails.payByCompany,
        }
      : {};
  const studentvalues =
    store.subscriptionType === "student"
      ? {
          payBySalary: false,
          educationName: personalDetails.educationName,
          educationInstituteName: personalDetails.educationInstitutionName,
          educationType: personalDetails.educationType,
          educationInstitute: personalDetails.educationInstitution,
          currentEducation: personalDetails.educationCurrent,
          educationStart: personalDetails.educationStarted,
          educationEnd: personalDetails.educationExpectedEnd,
          ...(personalDetails.isEducation
            ? {}
            : {
                ...(personalDetails.isTrainee
                  ? {
                      traineeCompany: personalDetails.traineeCompanyName,
                      companyWorkAreaPrioList: [
                        {
                          workArea: personalDetails.traineeWorkAreas.id,
                          workAreaName: personalDetails.traineeWorkAreas.name,
                          workFunction: personalDetails.traineeWorkFunctions.id,
                          workFunctionName: personalDetails.traineeWorkFunctions.name,
                          priority: 0,
                        },
                      ],
                      traineeStartDate: personalDetails.traineeStarted,
                      traineeEndDate: personalDetails.traineeExpectedEnd,
                      ...(personalDetails.traineeCompanyAddress.length
                        ? {
                            traineeAddress: personalDetails.traineeCompanyAddress,
                          }
                        : {}),
                      ...(personalDetails.traineeCompanyPostalCode.length
                        ? {
                            traineeZipCode: personalDetails.traineeCompanyPostalCode,
                          }
                        : {}),
                    }
                  : {}),
              }),
        }
      : {};

  const unemploymentvalues =
    store.subscriptionType === "unemployed"
      ? {
          ...(personalDetails.educationLevel
            ? {
                highestEducation: personalDetails.educationLevel.id,
              }
            : {}),
          educationStart: personalDetails.educationStarted,
          educationEnd: personalDetails.educationExpectedEnd,
          educationInstitute: personalDetails.educationInstitution,
          currentEducation: personalDetails.educationCurrent,
          companyWorkAreaPrioList: personalDetails.workSets.map((workSet, index) => {
            return {
              workArea: workSet.area.id,
              workAreaName: workSet.area.name,
              workFunction: workSet.function.id,
              workFunctionName: workSet.function.name,
              priority: index,
            };
          }),
        }
      : {};

  Object.assign(payload, nationalityvalues, unionvalues, unemploymentInsurancevalues, employedvalues, studentvalues, unemploymentvalues, residence);

  try {
    const result = await axios.post("/umbraco/api/signup/Enroll", payload);

    if (result.status === 200 && result.data.success && result.data.redirectUrl) {
      return result;
    }
  } catch (error) {
    if (window.appInsights) {
      window.appInsights.trackException({ error: error, severityLevel: 3, properties: { app: "(SIGNUP) (VUE)" } });
    }
    return false;
  }
}
